---
de:
  personal_tokens:
    connect:
      copy_prompt: Verbindungsanweisung kopieren
      prompt: 'Verbinde dich mit dem Kaia Portal MCP-Server. Transport: http. URL: {url}. Header: Authorization: Bearer {token}. Liste danach die Kraftwerke auf, die du sehen kannst.'
      step_copy: Kopieren Sie das Token oben; es wird nicht erneut angezeigt.
      step_tell: Geben Sie Ihrem KI-Assistenten die MCP-Adresse {url} und das Token und bitten Sie ihn, sich zu verbinden. Oder fügen Sie die fertige Anweisung unten ein.
      step_verify: Bitten Sie ihn, die sichtbaren Kraftwerke aufzulisten. Erhalten Sie eine Liste, sind Sie verbunden.
      title: KI-Assistenten verbinden
    copy: Token kopieren
    create: Token erstellen
    created_title: Token erstellt
    created_warning: Jetzt kopieren. Dieses Token wird nicht erneut angezeigt. Geben Sie es nur an den KI-Assistenten weiter, den Sie verbinden; im Zweifel widerrufen Sie es hier und erstellen ein neues.
    days: "{count} Tage"
    done: Fertig
    empty: Noch keine Tokens.
    errors:
      lifetime: Die Laufzeit muss %{allowed} Tage betragen
      minting_paused: Das Erstellen persönlicher MCP-Tokens ist pausiert
    expires: Läuft ab am {date}
    hint: Für MCP-Clients, die in Ihrem Namen handeln. Gleicher Anlagenzugriff wie dieses Konto.
    last_used: Zuletzt verwendet {date}
    lifetime: Läuft ab in
    name: Token-Name
    name_hint: Benennen Sie es nach dem Gerät oder Client, auf dem es liegt.
    never_used: Nie verwendet
    paused: Das Erstellen von Tokens ist pausiert, während wir die Compliance-Prüfung des MCP-Servers abschließen. Bestehende Tokens wurden widerrufen. Wir arbeiten daran, die Funktion zurückzubringen.
    revoke: Widerrufen
    revoke_named: "{name} widerrufen"
    revoke_text: "{name} funktioniert sofort nicht mehr. Dies kann nicht rückgängig gemacht werden."
    revoke_title: Token widerrufen?
    status:
      active: Aktiv
      expired: Abgelaufen
      expires_soon: Läuft bald ab
      revoked: Widerrufen
    title: Persönliche Zugriffstokens
    toast:
      copied: Token in die Zwischenablage kopiert
      copy_failed: Kopieren nicht möglich. Markieren Sie das Token und kopieren Sie es manuell.
      create_failed: Token konnte nicht erstellt werden
      created: Token erstellt
      load_failed: Tokens konnten nicht geladen werden
      prompt_copied: Verbindungsanweisung in die Zwischenablage kopiert
      revoke_failed: Token konnte nicht widerrufen werden
      revoked: Token widerrufen
